import { render, staticRenderFns } from "./StaffTable.vue?vue&type=template&id=31aa9df8&scoped=true"
import script from "./StaffTable.vue?vue&type=script&lang=js"
export * from "./StaffTable.vue?vue&type=script&lang=js"
import style0 from "./StaffTable.vue?vue&type=style&index=0&id=31aa9df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aa9df8",
  null
  
)

export default component.exports